import React, { useState } from "react";
import { Tab, Nav } from "react-bootstrap";
import { UiComponents } from "@simulanisindia/ui";
import { AppTrainingIcon, BottomActiveBar } from "../../../Icons";
import ResourceTabComponent from "./ResourceTabComponent";

const { SimCheckBox } = UiComponents;

const allApplicationsWithTabs = [
  {
    key: "application",
    navItem: {
      title: "Applications",
    },
    content: {
      component: () => <ResourceTabComponent type="apps" />,
    },
  },
  {
    key: "xrmodules",
    navItem: {
      title: "XRModules",
    },
    content: {
      component: () => <ResourceTabComponent type="resource" />,
    },
  },
  {
    key: "enviroments",
    navItem: {
      title: "Enviroments",
    },
    content: {
      component: () => <ResourceTabComponent type="resource" />,
    },
  },
  {
    key: "skillstream",
    navItem: {
      title: "Skill Stream Modules",
    },
    content: {
      component: () => <ResourceTabComponent type="resource" />,
    },
  },
  {
    key: "skillschool",
    navItem: {
      title: "Skill School Modules",
    },
    content: {
      component: () => <ResourceTabComponent type="resource" />,
    },
  },
];

const ResouceTabData = () => {
  const [activeTab, setActiveTab] = useState("application"); // default to 'application'

  const handleClick = (key) => {
    setActiveTab(key);
  };

  return (
    <div className="resource-mob">
      <Tab.Container activeKey={activeTab} onSelect={handleClick}>
        <div className="tabsMobile">
          <Nav variant="pills" className="tabfull">
            {allApplicationsWithTabs.map((item) => (
              <Nav.Item key={item.key}>
                <Nav.Link eventKey={item.key}>
                  <span className="tabCount">05</span>
                  <span className="tabText">{item.navItem.title}</span>
                  <span className="activeIndicator">
                    <BottomActiveBar />
                  </span>
                </Nav.Link>
              </Nav.Item>
            ))}
          </Nav>
        </div>
        <Tab.Content>
          {allApplicationsWithTabs.map((item) => (
            <Tab.Pane eventKey={item.key} key={item.key}>
              <button className="normalbtn d-flex align-items-center">
                <SimCheckBox /> Select All
              </button>
              {item.content.component()}
            </Tab.Pane>
          ))}
        </Tab.Content>
      </Tab.Container>
    </div>
  );
};

export default ResouceTabData;
